import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { AddManagerToChurchInput } from "baptize-america-client";
import { useState } from "react";
import DebouncedButton from "./DebounceButton";
import { containsUpperCase } from "../utils/helper";

interface AddManagerDialogProps {
  open: boolean;
  churchId: string;
  onClose: () => void;
  onConfirm: (input: AddManagerToChurchInput) => void;
}

const AddManagerDialog = ({
  churchId,
  open,
  onClose,
  onConfirm,
}: AddManagerDialogProps) => {
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [confirmEmail, setConfirmEmail] = useState<string>("");

  const [errors, setErrors] = useState<{
    firstName?: string;
    lastName?: string;
    email?: string;
    confirmEmail?: string;
  }>({});

  const validateInputs = () => {
    const newErrors: typeof errors = {};

    if (!firstName.trim()) newErrors.firstName = "First name is required.";
    if (!lastName.trim()) newErrors.lastName = "Last name is required.";
    if (!email.trim()) newErrors.email = "Email is required.";
    if (email && containsUpperCase(email))
      newErrors.email = "Email must not contain uppercase letters.";
    if (email !== confirmEmail) {
      newErrors.confirmEmail = "Emails do not match.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleConfirm = () => {
    if (!validateInputs()) return;

    onConfirm({ churchId, firstName, lastName, email });
    onClose(); // Close the dialog
  };

  return (
    <Dialog open={open}>
      <DialogTitle>Add Manager To Church</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            "& .MuiTextField-root": { m: 1 },
          }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          component="form"
          noValidate
          autoComplete="off"
        >
          <TextField
            required
            id="first-name"
            label="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            error={!!errors.firstName}
            helperText={errors.firstName}
          />
          <TextField
            required
            id="last-name"
            label="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            error={!!errors.lastName}
            helperText={errors.lastName}
          />
          <TextField
            required
            id="email"
            label="Email Address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email}
          />
          <TextField
            required
            id="confirm-email"
            label="Confirm Email Address"
            type="email"
            value={confirmEmail}
            onChange={(e) => setConfirmEmail(e.target.value)}
            error={!!errors.confirmEmail}
            helperText={errors.confirmEmail}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <DebouncedButton
          variant="contained"
          onClick={handleConfirm}
          sx={{ backgroundColor: "#00169E", color: "#FFF" }}
        >
          Confirm
        </DebouncedButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddManagerDialog;
